@use "ui/styles/colorsOld";
@use "ui/styles/colors";
@use "ui/styles/fonts";
@use "ui/styles/sizes";

.modalBodyContainer {
  :global {
    .modal-body {
      padding: sizes.$s0 sizes.$s6;
    }
  }
}

.wrapper {
  margin: sizes.$s6 0;
  color: colorsOld.$stoneDarkX1;

  :global {
    .icon-wrapper {
      display: flex;
      justify-content: center;
      margin-bottom: sizes.$s3;
    }

    .icon-background-circle {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      width: sizes.$s10;
      height: sizes.$s10;
      background-color: colors.$gray10;
    }

    .progress-wrapper {
      min-height: 40px;

      .progress-wrapper-text {
        text-align: center;
        margin-bottom: 12px;
      }
    }

    .error-wrapper {
      margin-bottom: 24px;

      .error-wrapper-text {
        color: colorsOld.$rubyDark;
        font-weight: 700;
        text-align: center;
        margin-bottom: 12px;
      }
    }

    .message-row {
      padding: sizes.$s3;
      font-size: 13px;
      border-radius: 4px;
      margin: 12px 0 0;
      display: flex;

      .message-text {
        margin-left: 18px;

        a {
          color: colorsOld.$sapphire;
          text-decoration: none;
        }
      }
    }
  }
}

.footerTerms {
  margin-right: auto;
  font-size: fonts.$small;
  color: colors.$gray60;

  a {
    color: colors.$blue;
    text-decoration: none;
  }
}

.messageRow {
  display: flex;

  & > :nth-child(2) {
    margin-left: 18px;
  }

  :global {
    .indented-message-cell {
      margin-left: 12px;
    }
  }
}
